import { Injectable } from '@angular/core';
import { TranslateService } from '@client/app/services/translate/translate.service';
import { AccessibilityTagsService } from '@client/app/modules/accessibility/services/tags/tags.service';

/**
 * Service to manage large data of the accessibilityDialogsHelpCenter component
 */
@Injectable({
    providedIn: 'root',
})
export class AccessibilityDialogsHelpCenterService {

    constructor (
        private translateService: TranslateService,
        private accessibilityTagsService: AccessibilityTagsService,
    ) {}

    /**
     * Get Accessibility Check Translation
     * @param guideline - Accessibility Guideline ID
     * @return Translation string
     */
    getGuidelineTranslation (guideline: any): any {
        const scope = {
            spanStart: '<span>',
            spanEnd: '</span>',
        };
        switch (guideline) {
            case 'WCAG2-A':
                return this.translateService.getString('[[spanStart]]WCAG 2.0[[spanEnd]] (Level A)', scope);
            case 'WCAG2-AA':
                return this.translateService.getString('[[spanStart]]WCAG 2.0[[spanEnd]] (Level AA)', scope);
            case 'WCAG2-AAA':
                return this.translateService.getString('[[spanStart]]WCAG 2.0[[spanEnd]] (Level AAA)', scope);
            case 'WCAG21-A':
                return this.translateService.getString('[[spanStart]]WCAG 2.1[[spanEnd]] (Level A)', scope);
            case 'WCAG21-AA':
                return this.translateService.getString('[[spanStart]]WCAG 2.1[[spanEnd]] (Level AA)', scope);
            case 'WCAG21-AAA':
                return this.translateService.getString('[[spanStart]]WCAG 2.1[[spanEnd]] (Level AAA)', scope);
        }
    }

    /**
     * Get Difficulty translation
     * @param level - Difficulty level
     * @return Translation string
     */
    getDifficultyTranslation (level: any): any {
        return this.translateService.getString('Level [[level]]', {
            level: level,
        });
    }

    /**
     * Get Tag Translation
     * @param tag - Tag name
     * @return Translation string
     */
    getTagTranslation (tag: any): any {
        return this.accessibilityTagsService.getTranslation(tag);
    }

    /**
     * Get Tag Class
     * @param tag - Tag name
     * @return CSS class string
     */
    getTagClass (tag: any): any {
        return this.accessibilityTagsService.getClass(tag);
    }
}
